export default {
  idOfQuestionBySlugAndIndex: (state: any) => (
    listSlug: string,
    index: number,
  ) => {
    return state.idOfQuestionBySlugAndIndex[listSlug][index];
  },
};
